import { Skeleton, Stack } from '@mui/material'
import React from 'react'

const ROWS = 6

export default function SectionRailSkeleton() {
  return (
    <Stack spacing={1.5} sx={{ p: 2 }} data-testid="avatar-section-rail-skeleton">
      {Array.from({ length: ROWS }, (_, i) => (
        <Stack key={i} spacing={0.5}>
          <Skeleton variant="text" width="70%" />
          <Skeleton variant="text" width="45%" height={14} />
        </Stack>
      ))}
    </Stack>
  )
}
